import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { DxTreeViewComponent } from 'devextreme-angular';

@Component({
  selector: 'app-crm-mail',
  templateUrl: './crm-mail.component.html',
  styleUrls: ['./crm-mail.component.css']
})
export class CrmMailComponent implements OnInit {
  @ViewChild(DxTreeViewComponent, { static: false }) treeView: DxTreeViewComponent;
  @Input() obj: any;
  contattiArray: any = [];
  sediArray: any = [];
  treeData: any[] = [];
  selectedMails: string[] = [];
  @Output() selectedMailsChange: EventEmitter<string[]> = new EventEmitter<string[]>();
  mailSelected: boolean = false;

  constructor() { }

  ngOnInit() {

    console.log('stampo data in ingresso', this.obj);
    this.treeData = this.transformToTreeData(this.obj);
  }

  ngAfterViewInit() {
    /* Applico questa funzione alla tree view per espandere tutti i nodi
    una volta caricato il componente.
    */
    this.treeView.instance.expandAll();
  }

  transformToTreeData(obj: any[]): any[] {
    const treeData = obj.map(item => {
      /* solo per il primo elemento con cod = 0 incremento l'id di 1 poichè 
      id 0 alla tree view di devextreme non piace. Inoltre, aggiungo in maniera statica
      (Sede Legale) al testo del valore della Ragione Sociale.
       */
      if (item.sede.Cod == 0) {
        return {
          id: 0.5,
          text: `${item.sede.RagSoc} (Sede Legale)`,
          items: item.contatti.map((contatto: any) => ({
            id: contatto.Cod,
            text: `${contatto.Mail && contatto.Mail.trim() ? `${contatto.Mail} (${contatto.RagSoc})` : ''}`,
            mail: contatto.Mail
          }))
        };
      }
      else return {
        id: item.sede.Cod,
        text: `${item.sede.Ind}${item.sede.Loc ? ', ' + item.sede.Loc : ''}`,
        items: item.contatti.map((contatto: any) => ({
          id: contatto.Cod,
          text: `${contatto.Mail && contatto.Mail.trim() ? `${contatto.Mail} (${contatto.RagSoc})` : ''}`,
          mail: contatto.Mail
        }))
      };
    });
    return treeData;
  }

  checkMail(mail: string): boolean {
    if (mail == null || mail == undefined || mail.trim() == '') return true
    return false
  }

  selectData(event: any) {
    // seleziono dall'evento in ingresso gli elementi selezionati.
    const selectedNodes = event.component.getSelectedNodes();
    this.selectedMails = selectedNodes
      .filter((node: any) => node.itemData && node.itemData.mail)
    this.selectedMailsChange.emit(this.selectedMails);
    console.log('selectedMails', this.selectedMails)

    //setto la variabile booleana a true solo se l'utente ha selezionato almeno una mail
    this.mailSelected = (this.selectedMails.length > 0) ? true : false;
  }
}